<template>
  <div v-if="!documentSigned" class="skribble-form-a card p-4">
    <div>
      <h3 class="mb-3">{{ $t('skr_form_title') }}</h3>
      <form v-if="form" @submit.prevent="sendForSigning">
        <!-- Contracting Partner Info -->
        <div class="form-row">
          <div class="form-group col-6">
            <label>{{ $t('skr_first_name') }}</label>
            <input
                v-model="form.sign_first"
                class="form-control"
                :class="{ 'is-invalid': invalidFields['partner_first'] }"
                type="text"
                ref="partner_first"
            />
          </div>
          <div class="form-group col-6">
            <label>{{ $t('skr_last_name') }}</label>
            <input
                v-model="form.sign_last"
                class="form-control"
                :class="{ 'is-invalid': invalidFields['partner_last'] }"
                type="text"
                ref="partner_last"
            />
          </div>
        </div>

        <div class="form-group">
          <label>{{ $t('skr_address') }}</label>
          <input
              v-model="form.sign_address"
              class="form-control"
              :class="{ 'is-invalid': invalidFields['partner_address'] }"
              type="text"
              ref="partner_address"
          />
        </div>

        <!-- Declaration -->
        <div class="form-group mt-3" v-if="this.default">
          <label>{{ $t('skr_declaration_label') }}</label>
          <div class="form-check">
            <input class="form-check-input" type="radio" id="owner_other" value="other" v-model="form.ownerType"/>
            <label class="form-check-label" for="owner_other">{{ $t('skr_owner_other') }}</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" id="owner_self" value="self" v-model="form.ownerType"/>
            <label class="form-check-label" for="owner_self">{{ $t('skr_owner_self') }}</label>
          </div>
        </div>

        <div class="form-group mt-3" v-else>
          <label>{{ $t('skr_declaration_label') }}</label>
          <div class="form-check">
            <input class="form-check-input" type="radio" id="owner_self" value="self" v-model="form.ownerType"/>
            <label class="form-check-label" for="owner_self">{{ $t('skr_owner_self') }}</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" id="owner_other" value="other" v-model="form.ownerType"/>
            <label class="form-check-label" for="owner_other">{{ $t('skr_owner_other') }}</label>
          </div>
        </div>

        <!-- Owners Section -->
        <div v-if="form.ownerType === 'other'" class="owners-area mt-2">
          <h5>{{ $t('skr_owners_title') }}</h5>

          <div v-for="(owner, idx) in form.owners" :key="idx" class="owner-card p-2 mb-2 border rounded">
            <div class="d-flex justify-content-between align-items-start">
              <strong>{{ $t('owner') }} #{{ idx + 1 }}</strong>
              <button type="button" class="btn btn-sm btn-outline-danger" @click="removeOwner(idx)" v-if="form.owners.length > 1">
                {{ $t('remove') }}
              </button>
            </div>

            <div class="form-row mt-2">
              <div class="form-group col-md-6">
                <label>{{ $t('skr_owner_last') }}</label>
                <input
                    v-model="owner.lastName"
                    class="form-control"
                    :class="{ 'is-invalid': invalidFields[`owner_${idx}_last`] }"
                    type="text"
                    :ref="`owner_${idx}_last`"
                />
              </div>

              <div class="form-group col-md-6">
                <label>{{ $t('skr_owner_first') }}</label>
                <input
                    v-model="owner.firstName"
                    class="form-control"
                    :class="{ 'is-invalid': invalidFields[`owner_${idx}_first`] }"
                    type="text"
                    :ref="`owner_${idx}_first`"
                />
              </div>

              <div class="form-group col-md-6">
                <label>{{ $t('skr_owner_dob') }}</label>
                <input
                    v-model="owner.dob"
                    class="form-control"
                    :class="{ 'is-invalid': invalidFields[`owner_${idx}_dob`] }"
                    type="date"
                    :ref="`owner_${idx}_dob`"
                />
              </div>

              <div class="form-group col-md-6">
                <label>{{ $t('skr_owner_nationality') }}</label>
                <input
                    v-model="owner.nationality"
                    class="form-control"
                    :class="{ 'is-invalid': invalidFields[`owner_${idx}_nationality`] }"
                    type="text"
                    :ref="`owner_${idx}_nationality`"
                />
              </div>

              <div class="form-group col-md-12">
                <label>{{ $t('skr_owner_address') }}</label>
                <input
                    v-model="owner.address"
                    class="form-control"
                    :class="{ 'is-invalid': invalidFields[`owner_${idx}_address`] }"
                    type="text"
                    :ref="`owner_${idx}_address`"
                />
              </div>

              <div class="form-group col-md-6">
                <label>{{ $t('skr_owner_country') }}</label>
                <input
                    v-model="owner.country"
                    class="form-control"
                    :class="{ 'is-invalid': invalidFields[`owner_${idx}_country`] }"
                    type="text"
                    :ref="`owner_${idx}_country`"
                />
              </div>
            </div>
          </div>

          <div class="text-right">
            <button type="button" class="btn btn-sm btn-outline-primary" @click="addOwner">
              {{ $t('skr_add_owner') }}
            </button>
          </div>
        </div>

        <!-- Submit -->
        <div class="mt-3">
          <div v-if="error" class="alert text-danger">{{ error }}</div>

          <button :disabled="loading" class="btn btn-primary">
            <span v-if="loading">
              <img width="50" height="50" src="/new-loader.svg" alt="loader"/>
            </span>
            <span v-else>{{ $t('skr_btn') }}</span>
          </button>
          <p v-if="skribbleError" class="text-danger mt-2" style="text-align: right;">
            {{ $t(skribbleError) }}
          </p>
        </div>
      </form>

      <SkribblePopup
          :show="showPopup"
          @cancel="showPopup = false"
          @continue="handlePopupConfirm"
      />
    </div>
  </div>
  <div v-else class="p-4 text-center">
    <h3 class="text-success text-large">{{ $t('skr_document_signed') }}</h3>
  </div>
</template>

<script>
export default {
  name: 'SkribbleFormA',
  data() {
    return {
      loading: false,
      documentSigned: false,
      default: false,
      showPopup: false,
      pollInterval: null,
      signing_url: null,
      skribbleError: null,
      error: null,
      country: '',
      form: null,
      invalidFields: {}
    }
  },
  async created() {
    const user = await this.refreshUser();
    const company = user.company || {};

    this.form = {
      sign_first: user.first_name || '',
      sign_last: user.last_name || '',
      sign_address: [
        user.address || '',
        user.address_nr || '',
        user.zip || '',
        user.city || '',
        user.country.name || ''
      ].filter(Boolean).join(', '),
      lang: this.$i18n.locale ? this.$i18n.locale : "de",
      owners: [
        {
          lastName: '',
          firstName: '',
          dob: '',
          nationality: '',
          address: '',
          country: ''
        }
      ],
      ownerType: 'self',
      date: new Date().toISOString().slice(0, 10),
      userID: user.id || '',
      companyID: company.id || ''
    };

    this.checkForForm();
  },

  methods: {
    async refreshUser() {
      try {
        let user = this.$store.state.auth.user;
        const { data } = await this.$http.post(`/getUserDataWithId/${user.id}`);

        if (data && data.value) {
          this.$store.commit("auth/SET_USER", data.value);
          return data.value;
        } else {
          console.warn("No user returned from backend");
          return user;
        }
      } catch (err) {
        console.error("Failed to refresh user:", err);
        return this.$store.state.auth.user;
      }
    },

    addOwner() {
      this.form.owners.push({lastName: '', firstName: '', dob: '', nationality: '', address: '', country: ''})
    },

    removeOwner(idx) {
      this.form.owners.splice(idx, 1)
    },

    async sendForSigning() {
      this.error = null
      this.skribbleError = null
      this.invalidFields = {}

      // validate partner
      if (!this.form.sign_first)    this.invalidFields['partner_first'] = true
      if (!this.form.sign_last)     this.invalidFields['partner_last'] = true
      if (!this.form.sign_address)  this.invalidFields['partner_address'] = true

      // validate owners if needed
      if (this.form.ownerType === 'other') {
        this.form.owners.forEach((o, idx) => {
          if (!o.lastName) this.invalidFields[`owner_${idx}_last`] = true
          if (!o.firstName) this.invalidFields[`owner_${idx}_first`] = true
          if (!o.dob) this.invalidFields[`owner_${idx}_dob`] = true
          if (!o.nationality) this.invalidFields[`owner_${idx}_nationality`] = true
          if (!o.address) this.invalidFields[`owner_${idx}_address`] = true
          if (!o.country) this.invalidFields[`owner_${idx}_country`] = true
        })
      }

      // if errors → scroll to first invalid field
      const firstInvalid = Object.keys(this.invalidFields)[0]
      if (firstInvalid) {
        this.error = this.$t('skr_error_fill_required')
        this.$nextTick(() => {
          const el = this.$refs[firstInvalid]
          if (Array.isArray(el)) el[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' })
          else el?.scrollIntoView({ behavior: 'smooth', block: 'center' })
          if (Array.isArray(el)) el[0]?.focus()
          else el?.focus()
        })
        return
      }

      // ✅ proceed with sending
      this.loading = true
      try {
        this.form.lang = this.$i18n.locale ? this.$i18n.locale : 'de';
        const payload = {form: this.form, form_type: 'formA'}
        const res = await this.$http.post('/skribble/send-for-signing', payload)
        const signingUrl = res?.data?.value?.signing_url || null

        if (!signingUrl) {
          this.skribbleError = "Internal server error";
        } else if (signingUrl) {
          this.signing_url = signingUrl;
          this.handleButtonClick(signingUrl)
        }
      } catch (err) {
        console.error(err)
        this.skribbleError = err.response?.data?.message || err.message || 'Something went wrong.'
      } finally {
        this.loading = false
      }
    },

    handlePopupConfirm() {
      this.showPopup = false;
      window.open(this.signing_url, '_blank');
      this.pollInterval = setInterval(this.checkSigningStatus, 10000)
    },

    handleButtonClick(signingUrl) {
      if (localStorage.getItem("hideSkribblePopup") === "true") {
        window.open(signingUrl, '_blank');
        this.pollInterval = setInterval(this.checkSigningStatus, 10000)
      } else {
        this.showPopup = true;
      }
    },

    checkSigningStatus() {
      this.$http.post(`/skribble/check-status/${this.form.userID}/formA`).then((res) => {
        if (res.data?.value === 'SIGNED') {
          clearInterval(this.pollInterval)
          this.pollInterval = null
          this.documentSigned = true
          window.location.reload();
        }
      }).catch(err => {
        console.error('Error checking signing status', err)
      });
    },

    checkForForm() {
      this.$http.post(`/company/tasks/check-for-form/`).then((res) => {
        if (res.data.value) {
          const result = res.data.value;
          const show = result.show_form;

          if (show) {
            if (result.form === "formK") {
              this.default = true;
              if (this.form) this.form.ownerType = 'other';
            } else {
              if (this.form) this.form.ownerType = 'self';
            }
          }
        }
      });
    },

  }
}
</script>

<style scoped>

.skribble-form-a {
  max-width: 820px;
  margin: 0 auto;
  background: #e1e1e12e;
}

.owner-card {
  background: #fbfbfb;
}

.is-invalid {
  border: 1px solid red !important;
}
</style>
